module.exports = __webpack_public_path__ + "img/sazman.9eaa14a.svg";